import React, { useCallback, useRef, useState } from 'react';
import moment from 'moment';
import 'moment-timezone';
import DatePicker from "react-datepicker";
import { Form } from 'react-bootstrap';
import Slider, { createSliderWithTooltip } from 'rc-slider';
import "react-datepicker/dist/react-datepicker.css";
import 'rc-slider/assets/index.css';
import { HexColorPicker, HexColorInput } from "react-colorful";
import useClickOutside from "./useClickOutside";
import { TimePicker } from 'antd';
export const commonRenderInput = ({ input, label, id, subLabel, need, placeholder, type, disabled, hidden, meta: { touched, error, warning } }) => {
  const needStar = need ? '*' : '';
  const classGroup = (type === 'hidden' || hidden) ? 'no-display' : 'form-group';
  const classShowLabel = label ? 'area-label' : 'no-display';

  return (
    <div className={classGroup}>
      <span className={classShowLabel}><span className='need-star-label'>{needStar}</span> <label>{label}</label><span className='sub-label'>{subLabel}</span></span>
      <input id={id} type={type} className="form-control" placeholder={placeholder} readOnly={disabled} {...input} />
      <div className='import-notice-text'>{touched && ((error && <span>{error}</span>) || (warning && <span className='warings'>{warning}</span>))}</div>
    </div>
  );
}

export const commonRenderRadio = ({ input, label, subLabel, need, placeholder, type, disabled, hidden, meta: { touched, error, warning } }) => {
  const classGroup = (type === 'hidden' || hidden) ? 'no-display' : 'form-group';

  return (
    <div className={classGroup}>
      <label style={{display: 'flex', alignItems: 'center', marginRight: '25px'}}>
        <input type="radio" className="form-control" disabled={disabled} readOnly={disabled} {...input} style={{width: 'auto', marginRight: '5px'}} />
        {label}
      </label>
    </div>
  );
}

export const commonRenderPicker = ({ openPickup, input, label, subLabel, need, type, disabled, placeholder }) => {
  const needStar = need ? '*' : '';
  const classGroup = type === 'hidden' ? 'no-display' : 'form-group';
  const classShowLabel = label ? 'area-label' : 'no-display';

  return (
    <div className={classGroup}>
      <span className={classShowLabel}><label>{label}</label><span className='need-star-label'>{needStar}</span><span className='sub-label'>{subLabel}</span></span>
      <input type='text' className={"form-control-select" + (disabled ? " not-allowed" : "")} readOnly={true} {...input} placeholder={placeholder}/>
      <span className={disabled ? 'area-pickup-icon no-display' : 'area-pickup-icon'} onClick={openPickup}><span className="icon-btn-add-n"></span></span>
    </div>
  );
}

export const toggleRenderSimpleInput = (field) => (
  <div className='form-group'>
    <input
      {...field.input}
      disabled={field.disabled}
      type="text"
      className="form-control"
    />
  </div>
);

export const commonRenderSelect = ({ callback, input, selectValue, label, subLabel, need, placeholder, type, disabled, options, meta: { touched, error, warning } }) => {
  const needStar = need ? '*' : '';
  const classGroup = type === 'hidden' ? 'no-display' : 'form-group';
  const classShowLabel = label ? 'area-label' : 'no-display';
  const name = input.name;
  const value = selectValue ? selectValue : input.value;

  return (
    <div className={classGroup}>
      <input type='hidden' className="form-control" placeholder={placeholder} readOnly={true} {...input} value={value}/>
      <Form.Group controlId={name}>
        <span className={classShowLabel}>
          <span className='need-star-label'>{needStar}</span> <Form.Label>{label}</Form.Label><span className='sub-label'>{subLabel}</span>
        </span>
        <Form.Control as="select" custom="true" onChange={callback} value={value} disabled={disabled} className="nw-type">
          {commonRenderSelectOptions(options)}
        </Form.Control>
      </Form.Group>
      <div className='import-notice-text'>{touched && ((error && <span>{error}</span>) || (warning && <span>{warning}</span>))}</div>
    </div>
  )
};

const commonRenderSelectOptions = (options) => {
  if (options) {
    return options
      .map((option, index) => {
        if (option !== null && option !== undefined) {
          return (
            option.hidden ? <option key={index} value={option.key} hidden></option>
                          : <option key={index} value={option.key || option}>{option.value || option}</option>
          )
        } else {
          return <option key={index} value="0" hidden></option>;
        }
      });
  }
}

export const commonRenderCheckbox = ({ id, callback, input, label, subLabel, need, disabled, meta: { touched, error, warning } }) => {
  const needStar = need ? '*' : '';

  let classIcon = input.value ? 'icon-btn-checkbox-p' : 'icon-btn-checkbox-n';
  let classAreaBtnCheck = disabled ? 'area-btn-check disabled' : 'area-btn-check';
  let classDisplayLabel = label ? 'area-label' : 'area-label no-display';
  const name = input.name;

  return (
    <div className='form-group'>      
      <input type='hidden' className="form-control" readOnly={disabled} {...input} />
      <div className={classAreaBtnCheck} onClick={callback}>
        <span id={id} className={classIcon} name={name}/>
        <span className={classDisplayLabel}><span className='need-star-label'>{needStar}</span> <label>{label}</label><span className='sub-label'>{subLabel}</span></span>
      </div>
      <div className='import-notice-text'>{touched && ((error && <span>{error}</span>) || (warning && <span>{warning}</span>))}</div>
    </div>
  )
}

export const commonRenderDatepicker = ({ callback, input, label, subLabel, need, type, disabled, meta: { touched, error, warning } }) => {
  // const needStar = need ? '*' : '';
  let inputContent, classAreaDatePicker, datePickerContent;
  let date = input.value ? moment(input.value, "YYYY-MM-DD").toDate() : new Date();

    inputContent = (
      <input type='hidden' className="form-control" readOnly={disabled} {...input} />
    );
    datePickerContent = (
      <DatePicker
          disabled={disabled}
          selected={date}
        onChange={(date) => {
          if (date) {
            const strDate = moment(date).format('YYYY-MM-DD');
            callback(strDate);
          }
        }}
        minDate={moment().toDate()}
        dateFormat="yyyy-MM-dd"
      />
    );
    classAreaDatePicker = 'area-datepick';

  const classGroup = type === 'hidden' ? 'no-display' : 'form-group';
  return (
    <div className={classGroup}>
      {/*<span className='area-label'><label>{label}</label><span className='need-star-label'>{needStar}</span><span className='sub-label'>{subLabel}</span></span>*/}
      { inputContent}
      <div className={classAreaDatePicker}>
        {datePickerContent}
      </div>
      <div className='import-notice-text'>{touched && ((error && <span>{error}</span>) || (warning && <span>{warning}</span>))}</div>
    </div>
  )
}

export const commonRenderTimepicker = ({ callback, input, label, subLabel, need, type, disabled, dvalue, meta: { touched, error, warning }, enabled }) => {
  // const needStar = need ? '*' : '';
  let inputContent, classAreaTimePicker, timePickerContent;
  let time = input.value ? moment(input.value, "HH:mm").toDate() : new Date();
  if (disabled) {
    inputContent = (
      <input type='text' className="form-control" readOnly={true} {...input} />
    );
    timePickerContent = (
      <span className="no-timepicker" />
    )
    classAreaTimePicker = 'area-timepicker no-display';
  } else {
    inputContent = (
      <input type='hidden' className="form-control" readOnly={disabled} {...input} />
    );
    timePickerContent = (
      <TimePicker
        value={moment(time, 'HH:mm')} 
        format={'HH:mm'}
        // defaultValue={dvalue}
        onChange={(value, dateString) => callback(value, dateString)}
        disabled={enabled}
      />
    );
    classAreaTimePicker = 'area-timepicker';
  }

  const classGroup = type === 'hidden' ? 'no-display' : 'form-group';
  return (
    <div className={classGroup}>
      {/* <span className='area-label'><label>{label}</label><span className='need-star-label'>{needStar}</span><span className='sub-label'>{subLabel}</span></span> */}
      { inputContent}
      <div className={classAreaTimePicker}>
        {timePickerContent}
      </div>
      <div className='import-notice-text'>{touched && ((error && <span>{error}</span>) || (warning && <span>{warning}</span>))}</div>
    </div>
  )
}

export const commonRenderTimeRangepicker = ({ callback, input, label, subLabel, need, type, disabled, fieldName, meta: { touched, error, warning } }) => {
  // const needStar = need ? '*' : '';
  let inputContent, classAreaTimePicker, timePickerContent;
  let time = [];
  if(input.value) {
    time.push(moment(input.value[0], "HH:mm"));
    time.push(moment(input.value[1], "HH:mm"));
  }

  if (disabled) {
    inputContent = (
      <input type='text' className="form-control" readOnly={true} {...input} />
    );
    timePickerContent = (
      <span className="no-timepicker" />
    )
    classAreaTimePicker = 'area-timepicker no-display';
  } else {
    inputContent = (
      <input type='hidden' className="form-control" readOnly={disabled} {...input} />
    );
    timePickerContent = (
      <TimePicker.RangePicker 
        onChange={(value, dateString) => callback(value, dateString, fieldName)} 
        defaultValue={time.length > 0 ? time : [moment.utc(new Date()).set({hour:6, minute:0}), moment.utc(new Date()).set({hour:20, minute:0})]} 
        inputReadOnly={true}
        format={'HH:mm'}
      />

    );
    classAreaTimePicker = 'area-timepicker';
  }

  const classGroup = type === 'hidden' ? 'no-display' : 'form-group';
  return (
    <div className={classGroup}>
      {/* <span className='area-label'><label>{label}</label><span className='need-star-label'>{needStar}</span><span className='sub-label'>{subLabel}</span></span> */}
      { inputContent}
      <div className={classAreaTimePicker}>
        {timePickerContent}
      </div>
      <div className='import-notice-text'>{touched && ((error && <span>{error}</span>) || (warning && <span>{warning}</span>))}</div>
    </div>
  )
}

export const commonRenderInlineInput = ({ input, label, placeholder, type, disabled, meta: { touched, error, warning } }) => {
  const classGroup = type === 'hidden' ? 'no-display' : 'form-group row inline-form-group';

  return (
    <div className={classGroup}>
      <div className='col-sm-6 area-form-label'><label>{label}</label></div>
      <div className='col-sm-6'><input type={type} className="form-control" placeholder={placeholder} readOnly={disabled} {...input} /></div>
      <div className='import-notice-text col-sm-12'>{touched && ((error && <span>{error}</span>) || (warning && <span>{warning}</span>))}</div>
    </div>
  )
}

export const commonRenderTableInput = ({ input, label, placeholder, type, disabled, meta: { touched, error, warning } }) => {
  const classGroup = type === 'hidden' ? 'no-display' : 'form-list-row';
  return (
    <tr className={classGroup}>
      <td className='area-form-list-col-label'>{label}</td>
      <td className='area-form-list-col-input'>
        <input type={type} className="form-control" placeholder={placeholder} readOnly={disabled} {...input} />
        <div className='import-notice-text'>{touched && ((error && <span>{error}</span>) || (warning && <span>{warning}</span>))}</div>
      </td>
    </tr>
  )
}

export const renderLabelBoxInput = ({ input, label, subLabel, need, placeholder, type, disabled, meta: { touched, error, warning } }) => {
  const needStar = need ? '*' : '';
  const classGroup = type === 'hidden' ? 'no-display' : 'form-group';
  const classShowLabel = label ? 'area-label' : 'no-display';
  const classLabelBox = 'label-box-fill';

  return (
    <div className={classGroup}>
      <div className={classLabelBox}>
        <h1 className={classShowLabel}><label>{label}</label><span className='need-star-label'>{needStar}</span><span className='sub-label'>{subLabel}</span></h1>
        <input type={type} className="form-control" placeholder={placeholder} readOnly={disabled} {...input} />
      </div>
      <div className='import-notice-text'>{touched && ((error && <span>{error}</span>) || (warning && <span>{warning}</span>))}</div>
    </div>
  )
}

const SliderWithTooltip = createSliderWithTooltip(Slider);
const sliderTipFormatter = (value) => {
  return `${value}`;
}

export const commonRenderSlider = ({ callback, input, label, subLabel, need, placeholder, type, disabled, min, max, markData, defaultValue, meta: { touched, error, warning } }) => {
  const needStar = need ? '*' : '';
  const classGroup = type === 'hidden' ? 'no-display' : 'form-group';
  const classShowLabel = label ? 'area-label' : 'no-display';
  const selectValue = input && input.value ? input.value : min;
  
  let mark = {};
  mark[min] = min;
  mark[max] = max;

  return (
    <div className={classGroup}>
      {/* The input will make slider's value mistake. */}
      {/* <input type='hidden' className="form-control" placeholder={placeholder} readOnly={true} {...input} /> */}
      <span className={classShowLabel}><span className='need-star-label'>{needStar}</span> <label>{label}</label><span className='sub-label'>{subLabel}</span></span>

      {markData ? <Slider marks={markData} defaultValue={defaultValue} onChange={callback} disabled={disabled} step={null} value={selectValue}
      /> : <SliderWithTooltip min={min} max={max} defaultValue={selectValue} marks={mark} onChange={callback} disabled={disabled} value={selectValue} 
        tipFormatter={sliderTipFormatter} tipProps={{ overlayClassName: 'foo' }}
      /> }
      <div className='import-notice-text'>{touched && ((error && <span>{error}</span>) || (warning && <span>{warning}</span>))}</div>
    </div>
  )
}

export const commonRenderSwitch = ({ id, callback, input, label, subLabel, need, placeholder, type, disabled, customStyle, meta: { touched, error, warning } }) => {
  const needStar = need ? '*' : '';
  const classGroup = type === 'hidden' ? 'no-display' : 'form-group';
  const classShowLabel = label ? 'area-label' : 'no-display';
  const classSwitch = customStyle ? ' '+customStyle : '';
  const name = input.name;
  const enabled = input.value;

  return (
    <div className={classGroup+classSwitch+" custom-control custom-switch"}>
      <input type='hidden' className="form-control" placeholder={placeholder} readOnly={true} {...input} />
      <span className='need-star-label'>{needStar}</span> <span className={classShowLabel}><label>{label}</label><span className='sub-label'>{subLabel}</span></span>

      <input id={id} type="checkbox" className="form-control custom-control-input" onChange={callback} checked={enabled?'checked':''} disabled={disabled} style={{display:'none'}}/>
      <label className="custom-control-label" htmlFor={name}></label>
      <div className='import-notice-text'>{touched && ((error && <span>{error}</span>) || (warning && <span>{warning}</span>))}</div>
    </div>
  )
}

export const commonRenderInputBox = ({ callback, input, label, subLabel, need, placeholder, type, disabled, customStyle, meta: { touched, error, warning } }) => {
  const needStar = need ? '*' : '';
  const classGroup = type === 'hidden' ? 'no-display' : 'form-group';
  const classShowLabel = label ? 'area-label' : 'no-display';
  const classCustomCheckbox = customStyle ? customStyle : '';
  const name = input.name;
  const enabled = input.value;

  return (
    <div className={classGroup}>
      <input type='hidden' className="form-control" placeholder={placeholder} readOnly={true} {...input} />
      <span className='need-star-label'>{needStar}</span> <span className={classShowLabel}><label>{label}</label><span className='sub-label'>{subLabel}</span></span>

      <input type="checkbox" className={"form-control "+classCustomCheckbox} id={name} onChange={callback} checked={enabled?'checked':''} disabled={disabled}/>
      <div className='import-notice-text'>{touched && ((error && <span>{error}</span>) || (warning && <span>{warning}</span>))}</div>
    </div>
  )
}

export const commonRenderCheckBox = ({ callback, input, label, subLabel, need, placeholder, type, disabled, customStyle, meta: { touched, error, warning } }) => {
  const needStar = need ? '*' : '';
  const classGroup = type === 'hidden' ? 'no-display' : 'form-group';
  const classShowLabel = label ? 'area-label' : 'no-display';
  const classCustomCheckbox = customStyle ? customStyle : '';
  const name = input.name;
  const enabled = input.value;

  return (
    <div className={classGroup}>
      <input type='hidden' className="form-control" placeholder={placeholder} readOnly={true} {...input} />
      <input type="checkbox" className={"form-control "+classCustomCheckbox} id={name} onChange={callback} checked={enabled?'checked':''} disabled={disabled}/>
      <span className='need-star-label'>{needStar}</span> <span className={classShowLabel}><label>{label}</label><span className='sub-label'>{subLabel}</span></span>
      <div className='import-notice-text'>{touched && ((error && <span>{error}</span>) || (warning && <span>{warning}</span>))}</div>
    </div>
  )
}
export const renderCheckBoxNetworkZone = ({ callback, input, label, subLabel, disabled, customStyle,  }) => {
    const classCustomCheckbox = customStyle ? customStyle : '';
    const name = input.name;
    const enabled = input.value;
    return (
        <div className="ip-form">
            <input type="checkbox" className={"form-control ip-checkbox "+classCustomCheckbox} id={name} onChange={callback} checked={enabled?'checked':''} disabled={disabled}/>
            <span className="ip-label"><label>{label}</label><span className='sub-label'>{subLabel}</span></span>
        </div>
    )
}

export const CommonRenderColorPicker = ({callback, input, value, placeholder, type, disabled, options, meta: { touched, error, warning }}) => {
  const [color, setColor] = useState(input.value);
  const popover = useRef();
  const [isOpen, toggle] = useState(false);
  const close = useCallback(() => toggle(false), []);
  useClickOutside(popover, close);
  return (
    <div className="picker">
      <input type='hidden' className="form-control" placeholder={placeholder} readOnly={true} {...input} value={value}/>
      <div className="picker-wrapper">
        <div
          className="swatch"
          style={{ backgroundColor: color }}
          onClick={() => toggle(true)}
        />
        <HexColorInput
          className="input"
          color={color}
          onChange={newColor => changeColor(newColor, callback, setColor)}
          onClick={() => toggle(true)}
          placeholder="Type a color"
          readOnly={true}
          prefixed
        />
      </div>
      {isOpen && (
        <div className="popover" ref={popover}>
          <HexColorPicker color={color} onChange={newColor => changeColor(newColor, callback, setColor)} />
        </div>
      )}
    </div>
  );
}

const changeColor = (newColor, callback, setColor) =>{
  if (callback){
    callback(newColor);
  }
  if(setColor){
    setColor(newColor);
  }
}

export const dateFormatter = (value, timezone, dateFormat) => {
  if (value) {
    const myTimezone = timezone ? timezone : "Asia/Taipei";
    const myDateFormat = dateFormat ? dateFormat : window.CONFIG.FORM_FORMAT.date;
    return moment.utc(value).tz(myTimezone).format(myDateFormat);
  }
  return "";
}
